import React, { createContext, useContext, useState, useCallback } from 'react';

const UIContext = createContext(null);

const initialModalState = {
  help: { isOpen: false, path: '' },
  email: { isOpen: false },
  wizard: { isOpen: false },
};

/**
 * État global UI : modales (aide, email, wizard), chargement, erreurs.
 * Permet d’ouvrir/fermer les modales depuis n’importe quel composant.
 */
export function UIProvider({ children }) {
  const [modals, setModals] = useState(initialModalState);
  const [globalError, setGlobalError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const openHelpModal = useCallback((path = '') => {
    setModals((prev) => ({
      ...prev,
      help: { isOpen: true, path },
    }));
  }, []);

  const closeHelpModal = useCallback(() => {
    setModals((prev) => ({
      ...prev,
      help: { isOpen: false, path: '' },
    }));
  }, []);

  const openEmailModal = useCallback(() => {
    setModals((prev) => ({
      ...prev,
      email: { isOpen: true },
    }));
  }, []);

  const closeEmailModal = useCallback(() => {
    setModals((prev) => ({
      ...prev,
      email: { isOpen: false },
    }));
  }, []);

  const openWizardModal = useCallback(() => {
    setModals((prev) => ({
      ...prev,
      wizard: { isOpen: true },
    }));
  }, []);

  const closeWizardModal = useCallback(() => {
    setModals((prev) => ({
      ...prev,
      wizard: { isOpen: false },
    }));
  }, []);

  const value = {
    modals,
    globalError,
    setGlobalError,
    isLoading,
    setIsLoading,
    openHelpModal,
    closeHelpModal,
    openEmailModal,
    closeEmailModal,
    openWizardModal,
    closeWizardModal,
  };

  return (
    <UIContext.Provider value={value}>
      {children}
    </UIContext.Provider>
  );
}

export function useUI() {
  const ctx = useContext(UIContext);
  if (!ctx) {
    throw new Error('useUI must be used within UIProvider');
  }
  return ctx;
}

export default UIContext;
